import { Link } from "react-router-dom";
import type { ActorItem } from "@/mocks/content";

export default function ActorCard({ actor }: { actor: ActorItem }) {
  return (
    <Link
      to={`/detail/${actor.id}`}
      className="group overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-200"
    >
      <div className="relative aspect-[4/5] w-full overflow-hidden bg-background-200">
        <img
          src={actor.cover}
          alt={`${actor.title} - 演员资料`}
          title={`${actor.title} 饰 ${actor.role} · 嫂子的诱惑演员资料`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-[1.03]"
        />
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-primary-950/85 via-primary-950/25 to-transparent p-3">
          <p className="font-heading text-base font-semibold text-background-50">{actor.title}</p>
          <p className="mt-0.5 text-xs text-background-100/80">饰 {actor.role}</p>
        </div>
        <span className="absolute right-2.5 top-2.5 rounded-full bg-background-50/90 px-2 py-0.5 text-[10px] font-medium text-primary-700">
          {actor.roleType}
        </span>
      </div>
      <div className="p-3">
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600">{actor.excerpt}</p>
        <span className="mt-2 inline-flex items-center gap-1 text-[11px] font-medium text-primary-600">
          查看资料
          <i className="ri-arrow-right-up-line text-xs" />
        </span>
      </div>
    </Link>
  );
}